module.exports = __webpack_public_path__ + "static/media/location.65f23267.png";